import React from 'react';
import { Link } from 'react-router-dom';
import formacoopLogo from '../assets/logo/formacoop-logo.png';
import qualiopiLogo from '../assets/logo/LogoQualiopi-300dpi-Avec-Marianne.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-col footer-links">
            <ul>
              <li><Link to="/">ACCUEIL</Link></li>
              <li><Link to="/a-propos">À PROPOS</Link></li>
              <li><Link to="/module-standard">MODULE STANDARD</Link></li>
              <li><Link to="/module-jeune">MODULE JEUNE</Link></li>
              <li><Link to="/contact">CONTACTEZ-MOI</Link></li>
            </ul>
          </div>

          <div className="footer-col center-col footer-contact">
            <p><strong>TÉLÉPHONE :</strong> 06 11 03 93 84</p>
            <p><strong>EMAIL :</strong> CATHY@HELPMINDFORMATION.FR</p>
            {/* <p><strong>ADRESSE :</strong> [Votre adresse ici]</p> */}
          </div>

          <div className="footer-col right-col">
            <img src={formacoopLogo} alt="Formacoop" className="footer-logos-img" />
            <img src={qualiopiLogo} alt="Qualiopi" className="footer-logos-img" />
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2025 HELP MIND FORMATION</p>
          <Link to="https://ramsford.fr" target='_blank' rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>
            <p>MADE BY <strong>*RAMSFORD</strong></p>
          </Link>
          <p><Link to="/mentions-legales" style={{ color: 'inherit', textDecoration: 'none' }}>MENTIONS LÉGALES</Link></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
